<template>
    <div class="ui-recent" :class="version == 'horiz'?'h-17':'h-19'">
        <div id="ui-server" v-if="serviceNumStatus"></div>
        <NoneData tips='加载中...' :version='version' class="flex" v-else></NoneData>
    </div>
</template>

<script>
import fitChartSize from "@/common/js/echartFontSize.js"
import NoneData from '@/components/NoneData.vue'
export default { 
    props:{ 
        lineList: {
            type: Array,
            default: []
        },
        serviceNumStatus:{
            type:Boolean,
            default:false
        },
        version:{
            type:String,
        },
    },
    components:{
        NoneData
    },
    watch:{
        lineList(val){ 
            this.proName = [];
            this.serviceNum = [];
            this.waterNum = [];
            val.map(item=>{
                this.proName.push(item.projectShortName?item.projectShortName:item.projectName);
                this.serviceNum.push(item.supplyNum);
                this.waterNum.push(Math.round(item.totalOutFlow/1000));
            }) 
            setTimeout(()=>{
                this.initServiceEcharts();
            },500) 
        } 
    },
    data () {
      return { 
          proName:[],
          serviceNum:[],//饮水人数
          waterNum:[],//饮水用量
          timer:null
      }
    }, 
    methods: {
        // 项目饮水人数与用水趋势
        initServiceEcharts(){
            if(this.serviceNumStatus){
                this.$nextTick(()=>{
                    let that = this;
                    let myChart = echarts.init(document.getElementById('ui-server'), null, { renderer: 'svg' })
                    let color = ['#25A6FF', '#FB9701'];
                    let option;
                    let proName = JSON.parse(JSON.stringify(that.proName));
                    let serviceNum = JSON.parse(JSON.stringify(that.serviceNum));
                    let waterNum = JSON.parse(JSON.stringify(that.waterNum));
                    if (that.proName.length || that.serviceNum.length || that.waterNum.length) {
                        if(this.timer){
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                        let option = {
                            color,
                            grid: {
                                top: '15%',
                                left: '5%',
                                bottom: "10%", // 增加底部空间以显示项目名称
                                right: "10%",
                                containLabel: true
                            },
                            legend: {
                                show: true,
                                top: '2%',
                                left: '6%',
                                itemHeight: fitChartSize(8),
                                itemWidth: fitChartSize(8),
                                data: ['饮水量(L)'],
                                // data: ['饮水量(L)', '饮水人数(人)'],
                                textStyle: {
                                    color: '#fff',
                                    fontSize: fitChartSize(12),
                                }
                            },
                            xAxis: {
                                type: 'category',
                                data: proName,
                                splitLine: {
                                    show: false,
                                }, 
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: '#677588'
                                    },
                                    fontSize: fitChartSize(12),
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLabel: {
                                    fontSize: fitChartSize(12),
                                    color: '#677588',
                                    interval: 0,
                                    rotate: 0 // 可以设置为45或-45来旋转标签，避免重叠
                                },
                            },  
                            dataZoom: [//滑动条
                                {
                                    xAxisIndex: 0,//控制x轴滚动
                                    show: false,//是否显示滑动条，不影响使用
                                    type: 'slider', // 这个 dataZoom 组件是 slider 型 dataZoom 组件
                                    startValue: 0, // 从头开始。
                                    endValue: 2,  // 一次性展示2个（索引0和1）。
                                    filterMode: 'none' // 不过滤数据，只改变显示范围
                                }, 
                            ],
                            yAxis: [{
                                type: 'value',
                                splitLine: {
                                    show: false,
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: '#677588'
                                    },
                                    fontSize: fitChartSize(14),
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLabel: {
                                    fontSize: fitChartSize(12),
                                    color: '#677588'
                                },
                            }],
                            series: [
                                {
                                    name: '饮水量(L)',
                                    type: 'bar',
                                    label: {
                                        normal: {
                                            position: 'top',
                                            show: true,
                                            textStyle: {
                                                color: '#fff',
                                                fontSize: fitChartSize(12),
                                            }
                                        },
                                    },
                                    barWidth: fitChartSize(15),
                                    data: waterNum, 
                                },
                                // {
                                //     name: '饮水人数(人)',
                                //     type: 'bar',
                                //     label: {
                                //         normal: {
                                //             position: 'right',
                                //             show: true,
                                //             textStyle: {
                                //                 color: '#fff',
                                //                 fontSize: fitChartSize(12),
                                //             }
                                //         }
                                //     },
                                //     barWidth: fitChartSize(15),
                                //     data: serviceNum, 
                                // }, 
                            ]
                        };
                        myChart.clear();
                        myChart.setOption(option, true);
                        window.addEventListener("resize", that.changeScreen(myChart));
                        
                        // 启动x轴动态滚动
                        this.timer = setInterval(function () {  
                            let currentEndValue = option.dataZoom[0].endValue;
                            let dataLength = proName.length;
                            
                            if (currentEndValue >= dataLength - 1) {
                                // 滚动到末尾，重置到开头
                                option.dataZoom[0].endValue = Math.min(1, dataLength - 1); 
                                option.dataZoom[0].startValue = 0;
                            } else {
                                // 继续向右滚动
                                option.dataZoom[0].endValue = currentEndValue + 1;
                                option.dataZoom[0].startValue = option.dataZoom[0].startValue + 1;
                            } 
                            myChart.setOption(option, true); 
                        }, 2000);
                        // let index = 0; //top多少就从多少开始
                        //     console.log(option.dataZoom[0].endValue)
                        // this.timer = setInterval(function () {
                        //     var axisData = that.proName[index];
                        //     var data0 = option.series[0].data;
                        //     var data1 = option.series[1].data;
                        //     data0.shift();
                        //     data1.shift();
                        //     data0.push(that.waterNum[index]);
                        //     data1.push(that.serviceNum[index]);
                        //     option.yAxis.data.shift();
                        //     option.yAxis.data.push(axisData);
                        //     myChart.setOption(option, true);
                        //     index += 1;
                        //     if (index >= that.proName.length) {
                        //         index = 0;
                        //     } 
                        //     myChart.setOption(option, true);
                        //     window.addEventListener("resize", that.changeScreen(myChart));
                        // }, 2000);
                    } else {
                        option = {
                            title: {
                                text: "暂无数据",
                                x: "center",
                                y: "center",
                                textStyle: {
                                    color: "#ccc",
                                    fontWeight: "normal",
                                    fill: "#9d9d9d",
                                    fontWeight: "bold",
                                    text: "暂无数据",
                                    fontFamily: "Microsoft YaHei",
                                    fontSize: fitChartSize(18)
                                }
                            }
                        };
                        myChart.clear();
                        myChart.setOption(option, true)
                        window.addEventListener("resize", that.changeScreen(myChart));
                    }
                })
            }
            
        },
        changeScreen(myChart){
            myChart.resize();
        }
    },
    destroyed(){ 
        // this.serviceNumStatus=false;
        if(this.timer){
            clearInterval(this.timer);
            this.timer = null;
        } 
        window.removeEventListener("resize",this.changeScreen)
    }
}
</script>

<style lang="scss" scoped> 
.h-19{ 
    height: 19.3rem;  
}
.h-17{ 
    // height: 15rem;  
    height: 100%;  
} 
#ui-server{ 
    height: 100%;  
}
</style>



// WEBPACK FOOTER //
// src/components/LineBarHome.vue